import { Controller } from 'stimulus'

const KEY_CODES = {
  escape: 27
}

const ITEM_SELECTOR = '.list-search-item'

export default class extends Controller {
  static targets = ['filter', 'content', 'btnGroup']

  initialize() {
    this._updateItemsVisibility()
    this._sortBy('total', 'desc')
  }

  // Stimulus event listeners

  onKeydown(aEvent) {
    this._onKeyDown(aEvent)
  }

  onInput(aEvent) {
    this._onInput(aEvent)
  }

  onSortChange(aEvent) {
    this._onSortChange(aEvent)
  }

  onBtnSortClick(aEvent) {
    this._onBtnSortClick(aEvent)
  }

  // Event handlers

  _onKeyDown(aEvent) {
    if (aEvent.keyCode === KEY_CODES['escape']) {
      this._clearSearch()
    }
  }

  _onInput(aEvent) {
    this._updateItemsVisibility()
  }

  _onSortChange(aEvent) {
    const sortType = aEvent.target.getAttribute('data-sort-type'),
          sortDirection = aEvent.target.getAttribute('data-sort-direction')

    this._sortBy(sortType, sortDirection)
  }

  _onBtnSortClick(aEvent) {
    const currentSortType = this.btnGroupTarget.getAttribute('data-current-sort-type'),
          sortType = aEvent.target.getAttribute('data-sort-type'),
          label = aEvent.target.nextElementSibling,
          icon = label.querySelector('i.fas')


    let sortDirection = aEvent.target.getAttribute('data-sort-direction')

    // inverte a direção do sort
    if (currentSortType === sortType) {
      if (sortDirection === 'asc') {
        sortDirection = 'desc'

        icon.classList.remove(icon.getAttribute('data-icon-asc'))
        icon.classList.add(icon.getAttribute('data-icon-desc'))
      } else {
        sortDirection = 'asc'

        icon.classList.remove(icon.getAttribute('data-icon-desc'))
        icon.classList.add(icon.getAttribute('data-icon-asc'))
      }
    }

    this._sortBy(sortType, sortDirection)

     aEvent.target.setAttribute('data-sort-direction', sortDirection)
  }

  // Private

  _sortBy(aSortType, aSortDirection) {
    const values = Array.from(this.element.querySelectorAll(ITEM_SELECTOR)).map((aItem) => {
      if (aSortType === 'name') {
        return aItem.getAttribute(`data-${aSortType}`)
      } else {
        return +(aItem.getAttribute(`data-${aSortType}`))
      }
    })

    const sortedValues = values.sort((a, b) => {
      let sortValue = 0

      if (a < b) {
        sortValue = -1
      } else if (a > b) {
        sortValue = 1
      }

      if (aSortType === 'name') {
        return sortValue
      } else {
        return -1 * sortValue
      }
    })

    this.element.querySelectorAll(ITEM_SELECTOR).forEach((aItem) => {
      let value = +(aItem.getAttribute(`data-${aSortType}`))

      if (aSortType === 'name') {
        value = aItem.getAttribute(`data-${aSortType}`)
      }

      let order = sortedValues.indexOf(value)
      if (aSortDirection === 'asc') {
        order = (sortedValues.length - sortedValues.indexOf(value))
      }

      aItem.style.order = order
    })

    this.btnGroupTarget.setAttribute('data-current-sort-type', aSortType)
    this.btnGroupTarget.setAttribute('data-current-sort-direction', aSortDirection)
  }

  _clearSearch() {
    this.filterTarget.value = ''

    this.element.querySelectorAll(ITEM_SELECTOR).forEach((aItem) => {
      aItem.classList.remove('d-none')
    })
  }

  _updateItemsVisibility() {
    const currentFilterText = (this._clearedString(this.filterTarget.value || ''))

    this.element.querySelectorAll(ITEM_SELECTOR).forEach((aItem) => {
      const searchText = this._clearedString(aItem.getAttribute('data-search-text')),
            found = searchText.indexOf(currentFilterText) !== - 1

      if (found) {
        aItem.classList.remove('d-none')
      } else {
        aItem.classList.add('d-none')
      }
    })
  }

  _clearedString(aString) {
    return (aString || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
  }
}
